module.exports = __webpack_public_path__ + "img/autokast.46a829c9.jpg";